import React from 'react';
import { CanonicalResellerOnboardingForm } from 'components';

const CanonicalResellerOnboardingComponent = () => {
    return <CanonicalResellerOnboardingForm />;
};

export default CanonicalResellerOnboardingComponent;
